import { useContext } from "react";
import { AscPlatformLayoutContext } from "./AscPlatformLayoutContext";

export function usePlatformSidebar() {
  const { setCollapseSidebar } = useContext(
    AscPlatformLayoutContext
  );
  function expandSidebar() {
    setCollapseSidebar?.(false);
  }
  function collapseSidebar() {
    setCollapseSidebar?.(true);
  }
  function toggleSidebar() {
    setCollapseSidebar?.((prev) => !prev);
  }

  return {
    expandSidebar,
    collapseSidebar,
    toggleSidebar,
  };
}
